<template>
  <transition
    v-if="item"
    name="fade"
    mode="out-in">
    <router-view
      :item="item"
      class="full-size" />
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { routeMixin } from '../mixins'

const scrollOptions = {
  container: '.youtube-layout-container',
  easing: 'ease-in',
  offset: -20,
  force: true,
  cancelable: true,
  onStart (element) {
    // scrolling started
  },
  onDone (element) {
    // scrolling is done
  },
  onCancel () {
    // scrolling has been interrupted
  },
  x: false,
  y: true
}

export default {
  mixins: [routeMixin],
  data () {
    return {
      rightColumnTabIndex: 0
    }
  },
  computed: {
    ...mapState('search', [
      'index'
    ]),
    ...mapGetters('authentication', [
      'isGuest'
    ]),
    ...mapState([
      'panels'
    ]),
    itemId () {
      return this.$route.params.id
    },
    panel () {
      return this.panels[this.itemId]
    },
    item () {
      return this.itemId && this.index[this.itemId]
    },
    container () {
      return this.item && this.item.getContainer()
    },
    routeWithRightColumns () {
      return this.$route.matched && this.$route.matched.find(route => route.meta.rightColumns)
    },
    metaRightColumns () {
      return this.routeWithRightColumns ? this.routeWithRightColumns.meta.rightColumns : []
    },
    relevantItems () {
      return (this.panel
              && this.panel
                .relevantItems
                .concat(this.metaRightColumns)
                .filter(c => c.component && (!c.filter || c.filter({ isGuest: this.isGuest })))
      ) || this.metaRightColumns
    }
  },
  methods: {
    scrollToContent () {
      this.$scrollTo('.top-content-anchor', 500, scrollOptions)
    }
  },
  watch: {
    '$route' (to, from) {
      this.$nextTick(() => {
        this.rightColumnTabIndex = 0
        setTimeout(this.scrollToContent, 200)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
